import { connect } from 'react-redux';

import EditGoalPage from '../components/EditGoalPage/EditGoalPage';

const mapStateToProps = state => ({
  organisation: state.organisations.organisation
});

export default connect(mapStateToProps)(EditGoalPage);
